var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23858 2.23858 0 5 0H45C47.7614 0 50 2.23858 50 5V45C50 47.7614 47.7614 50 45 50H5C2.23858 50 0 47.7614 0 45V5ZM25 13C22.9289 13 21.25 14.511 21.25 16.375C21.25 18.239 22.9289 19.75 25 19.75C27.0711 19.75 28.75 18.239 28.75 16.375C28.75 14.511 27.071 13 25 13ZM22.0833 32.8857H21.0417C20.4664 32.8857 20 33.3055 20 33.8232V36.0625C20 36.5803 20.4664 37 21.0417 37H28.9583C29.5336 37 30 36.5803 30 36.0625V33.8232C30 33.3055 29.5336 32.8857 28.9583 32.8857H27.9167V22.9375C27.9167 22.4197 27.4503 22 26.875 22H21.0417C20.4664 22 20 22.4197 20 22.9375V25.1768C20 25.6945 20.4664 26.1143 21.0417 26.1143H22.0833V32.8857Z",
    fill: "#E3AE02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoButton);
export default __webpack_public_path__ + "static/media/info_button.7e493e1c9bdbe53c165b23b502592267.svg";
export { ForwardRef as ReactComponent };